"use strict";

exports.__esModule = true;
exports.Dropdown = void 0;
var _react = _interopRequireWildcard(require("react"));
var _jsxRuntime = require("react/jsx-runtime");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/* eslint-disable import/prefer-default-export */
/* eslint react/forbid-prop-types: 0 */

function buttonProps(isButtonActive, callback) {
  return isButtonActive ? {
    onClick: callback,
    onKeyDown: callback,
    role: 'button',
    tabIndex: 0
  } : {};
}
const Dropdown = props => {
  const {
    types,
    items,
    selection,
    open,
    setOpen,
    onChange,
    cssModifier,
    onDropdownLeave,
    hasHeaderButton,
    hasItemButton,
    active,
    setActiveMenu,
    id,
    isOpen,
    setIsOpen,
    isHoverOpen,
    setOpenMenu
  } = props;
  const labelProps = items && items[0];
  const SingleItem = items.length === 1 && (labelProps == null ? void 0 : labelProps.type) && types[`${labelProps.type}`];
  const HeadItem = items.length > 1 && (labelProps == null ? void 0 : labelProps.type) && types[`${labelProps.type}`];
  const options = items.slice(1);
  const OptionItems = options.map(option => (option == null ? void 0 : option.type) && types[`${option.type}`]);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
    onMouseLeave: onDropdownLeave,
    className: "ccl-e-custom-dropdown",
    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      className: `ccl-e-custom-dropdown__container ccl-e-custom-dropdown__container--${cssModifier} ccl-e-custom-dropdown__container--${cssModifier}-open-${open} `,
      children: [SingleItem && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        className: ['ccl-e-custom-dropdown__container__header', `ccl-e-custom-dropdown__container__header--${cssModifier}`, active ? `ccl-e-custom-dropdown__container__header--${cssModifier}--active` : ''].join(' '),
        ...buttonProps(hasHeaderButton, () => {
          setActiveMenu(id);
          setIsOpen(false);
          onChange(items[0]);
        }),
        onMouseOver: () => setOpenMenu(undefined),
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(SingleItem, {
          ...labelProps
        })
      }), HeadItem && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        className: ['ccl-e-custom-dropdown__container__header', `ccl-e-custom-dropdown__container__header--${cssModifier}`, active ? `ccl-e-custom-dropdown__container__header--${cssModifier}--active` : ''].join(' '),
        ...buttonProps(hasHeaderButton, () => {
          setOpen(!open);
        }),
        onMouseOver: () => isHoverOpen && isOpen && setOpen(true),
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(HeadItem, {
          ...labelProps,
          open: open,
          setOpen: setOpen,
          selection: selection
        })
      }), open && /*#__PURE__*/(0, _jsxRuntime.jsx)("ul", {
        className: `ccl-e-custom-dropdown__container__list-items ccl-e-custom-dropdown__container__list-items--${cssModifier}`,
        children: OptionItems == null ? void 0 : OptionItems.map((Item, index) => {
          const optionProps = options[index];
          // selection[optionProps.id] ? 'active' : 'default'
          return /*#__PURE__*/(0, _jsxRuntime.jsx)("li", {
            className: `ccl-e-custom-dropdown__container__list-items__item ccl-e-custom-dropdown__container__list-items__item--${cssModifier} ccl-e-custom-dropdown__container__list-items__item--${cssModifier}--${selection[optionProps.id] ? 'active' : 'default'}`,
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
              className: `ccl-e-custom-dropdown__container__list-items__item__button ccl-e-custom-dropdown__container__list-items__item__button--${cssModifier}`,
              ...buttonProps(hasItemButton, () => {
                // eslint-disable-next-line no-unused-expressions
                !optionProps.isDisabled ? onChange(optionProps) : undefined;
                setActiveMenu(id);
                setIsOpen(false);
              }),
              disabled: optionProps.isDisabled,
              children: /*#__PURE__*/(0, _react.createElement)(Item, {
                ...optionProps,
                isSelected: !!selection[optionProps.id],
                key: optionProps.id,
                handleClick: () => {
                  onChange(optionProps);
                }
              })
            })
          }, optionProps.id);
        })
      })]
    })
  });
};
exports.Dropdown = Dropdown;
Dropdown.defaultProps = {
  open: false,
  onDropdownLeave: undefined,
  hasHeaderButton: true,
  hasItemButton: true,
  setActiveMenu: () => {},
  isOpen: false,
  isHoverOpen: false,
  setOpenMenu: () => {}
};